import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { styled } from "../css/styled";
import { Pressable as NativePressable, Platform } from "react-native";
var StyledPressable = styled(NativePressable)(function(param) {
    var showCursor = param.showCursor;
    return _object_spread({}, Platform.select({
        web: {
            cursor: showCursor ? "pointer" : "default"
        }
    }));
});
export var Pressable = /*#__PURE__*/ React.forwardRef(function Pressable(props, ref) {
    return /*#__PURE__*/ _jsx(StyledPressable, _object_spread_props(_object_spread({
        showCursor: !!(props.onPress || props.accessibilityRole === "link" || !props.disabled)
    }, props), {
        ref: ref,
        children: props.children
    }));
});
